import type { BatchSettings, CurrentNftPoolType } from "../types";
import { ChainId } from "../chain-specific";
import type { ChainIdSupportListType } from "./types";

/**
 * The base URL for the project, can be overridden by the NEXT_PUBLIC_BASE_URL environment variable
**/
export const baseUrl: string =
    process.env.NEXT_PUBLIC_BASE_URL ?? 'https://app.chewyswap.dog/'

export const batchSettings: BatchSettings = {
    maxBatchClaim: 55,
    maxBatchStake: 100,
    maxBatchUnstake: 30,
}

export const lastPoolIdDefault: CurrentNftPoolType = {
    poolId: 1,
    chainId: ChainId.SHIBARIUM
}

export const multiPool = true; // toggles showing multi pool UI

export const projectName = "ChewySwap"
export const projectNameShort = "ChewySwap"
export const pageTitle = `${projectNameShort ? projectNameShort : projectName}` // title that shows in UI

export const imageLogo: boolean = true
export const logoWidth = 300
export const logoHeight = 50
export const logoExt = 'svg'
export const footerExt = 'gif'
export const ogExt = 'jpg'

export const metaTitle = "ChewySwap"
export const metaDescription = "Stake tokens and LP, launch projects on Shibarium and Dogechain using our staking aggregator and launchpad platform!"
export const aggregatorTitle = "ChewySwap DEX Aggregator for Shibarium & Dogechain"
export const aggregatorDescription = "DEX aggregator for Shibarium and Dogechain, providing the best prices and liquidity for your trades. Trades across different Exchanges and Pairs"

export const twitter = 'https://twitter.com/ChewySwap'
export const twitterId = '1693639723984547840'
export const twitterAt = "@ChewySwap"
export const telegram = 'https://t.me/ChewySwapCommunity'
export const website = 'https://chewyswap.dog'

export const chartUrl = 'https://dexscreener.com/shibarium/0x324eef33af720ce44deab7e32f4367a82b4ea43b'
export const chartPage = `..../../link?to=https://${chartUrl}${encodeURIComponent(`?embed=1&theme=dark"`)}`

export const tokenContractAddress = '0x2761723006d3Eb0d90B19B75654DbE543dcd974f'
export const defaultTokenChainSlug = 'shibarium'
export const chewyswapBaseUrl = 'https://chewyswap.dog/swap/'
export const chewyLink = `${chewyswapBaseUrl}${encodeURIComponent(`?chain=${defaultTokenChainSlug}&outputCurrency=${tokenContractAddress}`)}`
export const footerLink = `../../../link?to=${chewyLink}`

export const toastTheme = "dark" // dark or light

export const projConfig = {
    siteName: metaTitle,
    siteDescription: metaDescription,
    siteUrl: baseUrl,
    githubUrl: 'https://github.com/ChewySwap',
    author: 'Chewy Doggo',
    authorUrl: 'https://chewyswap.dog',
    nav: [
        {
            name: 'Home',
            path: '/'
        },
        /*
        {
            name: 'Mint',
            path: '/mint/'
        },
        */
        {
            name: 'Blog (Server)',
            path: '/news/'
        },
        {
            name: 'GitHub Repo',
            path: 'https://github.com/gregrickaby/nextjs-app-router-examples'
        }
    ],
    layout: {
        showPoolsInMenu: false,
    }
}

export const supportedChainIds: ChainIdSupportListType = {
    farms: [ChainId.SHIBARIUM, ChainId.DOGECHAIN],
    pools: [ChainId.SHIBARIUM, ChainId.DOGECHAIN],
    aggregator: [ChainId.SHIBARIUM, ChainId.DOGECHAIN],
    swap: [ChainId.SHIBARIUM, ChainId.DOGECHAIN],
    nfts: {
        mint: [],
        stake: [ChainId.SHIBARIUM]
    },
    bridge: [ChainId.DOGECHAIN],
    tools: {
        multisender: {
            token: [ChainId.SHIBARIUM, ChainId.DOGECHAIN],
            nft: [ChainId.SHIBARIUM, ChainId.DOGECHAIN]
        },
        v3lp: [ChainId.SHIBARIUM, ChainId.DOGECHAIN],
        deployer: [ChainId.SHIBARIUM, ChainId.DOGECHAIN]
    }
}

export type RequiredNftMintChainType = 109 | 2000; // Default NFT Mint Chains
export type RequiredFarmChainType = 109 | 2000; // Default MasterChef Chains
export type RequiredAggregatorChainType = 109 | 2000; // Default Aggregator Chains
export type RequiredNftPoolChainType = 109 | 2000; // Specify the required ChainTypes
export type RequiredTokenListType = 109 | 2000; // Specify the required ChainTypes